import {
    EyeIcon,
    CollectionIcon,
    ChartPieIcon,
    LockClosedIcon,
    UsersIcon,
    DocumentDuplicateIcon, SwitchHorizontalIcon,
} from '@heroicons/react/outline'
import {activeBucket_, buckets_, loadingText_} from "../../App";
import {useRecoilState} from "recoil";
import React, {useState} from "react";
import {humanFileSize} from "../../utils/v56l_file";
import {getJsonFieldValue} from "../../v56_api";
//import { useBeforeunload } from 'react-beforeunload';

// const url = new URL('https://ws.vault56.com/.well-known/mercure');
// url.searchParams.append('topic', 'https://example.com/books/{id}');
// url.searchParams.append('topic', 'https://example.com/users/dunglas');
// const eventSource = new EventSource(url);
// eventSource.onmessage = e => console.log(e); // do something with the payload

export default function V56BucketList({callBackEdit, callBackNew, callBackAccess, callBackBrowse}) {

    const [activeBucket, setActiveBucket] = useRecoilState(activeBucket_);
    const [loadingText, setLoadingText] = useRecoilState(loadingText_);
    const [scaleEffect, setScaleEffect] = useState(false);
    const [buckets, setBuckets] = useRecoilState(buckets_);

    /**
     * Combines multiple class strings to one
     * @param classes
     * @returns {string}
     */
    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    // useBeforeunload((event) => {
    //     event.preventDefault();
    //     eventSource.close();
    // }, []);

    function getBucketQuotaType(value) {
        if (value === 'k') {
            return 'kB';
        } else if (value === 'm') {
            return 'MB';
        } else if (value === 'g') {
            return 'GB';
        } else if (value === 't') {
            return 'TB';
        } else {
            return 'B';
        }
    }

    function getBytesFromBucketQuota(quota_type, quota_amount) {
        if (quota_type === 'k') {
            return quota_amount * 1000;
        } else if (quota_type === 'm') {
            return quota_amount * 1000 * 1000;
        } else if (quota_type === 'g') {
            return quota_amount * 1000 * 1000 * 1000;
        } else if (quota_type === 't') {
            return quota_amount * 1000 * 1000 * 1000 * 1000;
        } else {
            return 0;
        }
    }

    function getBucketPercentUsage(bucket) {
        if (bucket.quota_type === false) {
            return 0;
        } else {
            return Math.round((bucket.bucket_size / getBytesFromBucketQuota(bucket.bucket_quota_type, bucket.bucket_quota_amount)) *100);
        }
    }

    function getBucketUsageString(bucket) {
        if (bucket.number_of_files === 0) {
            return 'Bucket is empty';
        }

        return bucket.number_of_files + ' ' + (bucket.number_of_files === 1?'file':'files') + ', ' + humanFileSize(bucket.bucket_size) + (bucket.bucket_quota === false?'':', ' + getBucketPercentUsage(bucket) + '% full');
    }

    function hasShadowCopy(bucket) {
        return (getJsonFieldValue(bucket.properties, 'backup_target', '') !== '');
    }

    function shadowCopyInSync(bucket) {
        return (getJsonFieldValue(bucket.properties, 'backup_target', '') !== '' && getJsonFieldValue(bucket.properties, 'backup_target_synced', '') === 'true');
    }

    const RenderBuckets = React.useCallback(() => {
        return (
            buckets.map((bucket) => (
                <li key={bucket.id} className="col-span-1 bg-white rounded-lg shadow-lg hover:shadow-2xl divide-y divide-gray-200">
                    <div className="float-left p-4">
                        <span className="text-gray-500">{getBucketUsageString(bucket)}</span>
                    </div>
                    <div className="float-right">
                        <span className="flex-shrink-0 inline-block text-gray-400 text-xs font-medium px-1 py-2">
                            {bucket.bucket_quota ?
                                <span title={'Quota enabled: ' + bucket.bucket_quota_amount + getBucketQuotaType(bucket.bucket_quota_type)}><ChartPieIcon className="h-6 w-6 pl-1"/>{bucket.bucket_quota_amount + getBucketQuotaType(bucket.bucket_quota_type)}</span> : ''
                            }
                        </span>
                        <span title={bucket.bucket_retention ? 'Ransomware protection is enabled' : 'Ransomware protection is disabled'}
                              className="flex-shrink-0 inline-block px-1 py-2">
                        {bucket.bucket_retention ?
                            <LockClosedIcon className="text-gray-400 h-6 w-6"/> :
                            ''
                        }
                        </span>
                        {' '}
                        <span title={bucket.bucket_versioning ? 'Versioning is enabled' : 'Versioning is disabled'}
                              className="flex-shrink-0 inline-block px-1 py-2">
                        {bucket.bucket_versioning ?
                            <DocumentDuplicateIcon className="text-gray-400 h-6 w-6"/> :
                            ''
                        }
                        </span>
                        {' '}
                        <span title={hasShadowCopy(bucket) ? shadowCopyInSync(bucket)?'Shadow Copy OK':'Shadow Copy in progress' : ''}
                              className="flex-shrink-0 inline-block px-1 py-2">
                        {hasShadowCopy(bucket) ?
                            <SwitchHorizontalIcon
                                className={classNames(
                                    shadowCopyInSync(bucket) ? "text-green-400" : "text-[#e67423] animate-pulse",
                                    "h-6 w-6"
                                )}
                            /> :
                            ''
                        }
                        </span>
                    </div>

                    <div className="w-full flex items-center justify-between p-6 space-x-6">
                        <div className="flex-1 truncate">
                            <div>
                                <div className="flex items-center">
                                    <h3 className="text-gray-900 text-sm font-medium truncate">{bucket.bucket_name}</h3>
                                    <button
                                        type="button"
                                        className={classNames(
                                            scaleEffect === bucket.id ? "animate-scaleDown font-large" : 'font-small text-gray-400',
                                            "px-2 py-1.5 border-2 ml-auto hover:border-[#5f2881] text-sm text-gray-400 hover:text-[#5f2881] rounded-md"
                                        )}
                                        onClick={() => {
                                            navigator.clipboard.writeText(bucket.id);
                                            setScaleEffect(bucket.id);
                                        }}
                                        onAnimationEnd={() => setScaleEffect(false)}
                                    >
                                        Copy ID
                                    </button>
                                </div>
                                <p className="mt-1 text-gray-500 text-sm truncate">{bucket.bucket_description}<span className="text-white">.</span></p>
                            </div>
                        </div>
                        {/*<img className="w-10 h-10 bg-gray-300 rounded-full flex-shrink-0" src={bucket.imageUrl} alt="" />*/}
                    </div>
                    <div>
                        <div className="-mt-px flex divide-x divide-gray-200">
                            <div className="w-0 flex-1 flex">
                                <a
                                    href='#'
                                    onClick={() => {
                                        setActiveBucket(bucket);
                                        callBackEdit();
                                    }}
                                    className="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
                                >
                                    <EyeIcon className="w-5 h-5 text-gray-400" aria-hidden="true"/>
                                    <span className="ml-2">Settings</span>
                                </a>
                            </div>
                            <div className="-ml-px w-0 flex-1 flex">
                                <a
                                    href='#'
                                    onClick={() => {
                                        setActiveBucket(bucket);
                                        callBackBrowse();
                                    }}
                                    className={classNames(
                                        "relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
                                    )}
                                >
                                    <CollectionIcon className="w-5 h-5 text-gray-400" aria-hidden="true"/>
                                    <span className="ml-2">Browse</span>
                                </a>
                            </div>
                            <div className="-ml-px w-0 flex-1 flex">
                                <a
                                    href='#'
                                    className="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
                                    onClick={() => {
                                        setActiveBucket(bucket);
                                        callBackAccess();
                                    }}
                                >
                                    <UsersIcon className="w-5 h-5 text-gray-400" aria-hidden="true"/>
                                    <span className="ml-2">Access</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
            ))

        )
    }, [buckets]);

    return (
        <ul role="list" className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            <button
                type="button"
                className="relative block w-full border-2 border-gray-300 border-dashed rounded-lg text-center hover:border-gray-400"
                onClick={callBackNew}
            >
                <svg className="mx-auto h-12 w-12 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330.87 329.87">
                    <path d="M210.67609,306.20331c-12.62378,2.26306-27.69061,3.66827-45.23956,3.66827-59.49658,0-90.62354-16.59668-93.94531-28.51465l-7.19318-37.57397c28.83386,19.27338,64.0744,29.72339,101.13849,29.72339,13.77216,0,27.29144-1.44562,40.32483-4.24774,1.06158-7.9693,3.44702-15.51538,6.9339-22.41583-14.82416,4.31189-30.7204,6.66357-47.25873,6.66357-42.20361,0-80.25977-15.25372-106.85132-39.5647l-23.78815-124.25922c29.7207,15.68457,80.37653,23.75946,130.63947,23.75946s100.91882-8.07501,130.63947-23.7597l-22.65729,118.35046c.80017-.02679,1.59851-.06079,2.40521-.06079,8.88824,0,17.38562,1.65552,25.22168,4.64948,19.38116-23.79626,29.82745-52.10004,29.82745-81.84448,0-16.24219-3.13477-32.17773-9.31738-47.36523-.68652-1.68646-1.78619-3.07666-3.1283-4.11823l2.6947-14.07562c.94843-2.72095,1.44531-5.55292,1.44531-8.49658,0-.02045-.00195-.04047-.00201-.06091-.00043-.08771-.00598-.17432-.00873-.26166C322.09869,19.37219,243.29333,0,165.43652,0,87.58423,0,8.78418,19.36975,8.31616,56.39148c-.00293,.09088-.00867,.18097-.00909,.27228-.00006,.01929-.00189,.03815-.00189,.05743,0,2.94275,.49652,5.77386,1.44434,8.49396l2.52356,13.18195c-.92487,.90039-1.69043,1.99493-2.2262,3.25769C3.38037,97.3667,0,113.89404,0,130.77686c0,34.66156,14.17328,67.37115,40.15533,93.26453l11.75531,61.40442c.03564,.18555,.07617,.36914,.12207,.55176,6.68262,26.65234,51.19629,43.87402,113.40381,43.87402,21.22089,0,40.29346-1.9118,56.49567-5.44672-4.61609-5.4325-8.43829-11.56061-11.2561-18.22156Zm100.19696-175.42645c0,16.90698-4.07263,33.02631-11.43286,47.69653l10.98279-57.36884c.29645,3.20709,.45007,6.4325,.45007,9.6723Zm-290.87305,0c0-3.23706,.15576-6.45825,.45123-9.66089l10.97974,57.35339c-7.35901-14.66919-11.43097-30.78705-11.43097-47.6925ZM29.05005,59.66272l-.69611-3.63629c1.64374-12.96405,48.64972-36.02643,137.08258-36.02643s135.44171,23.0639,137.08234,36.02777l-.69556,3.63318c-6.29388,13.20685-52.85858,33.78143-136.38678,33.78143S35.34717,72.86957,29.05005,59.66272Z"/>
                    <path d="M272.07281,233.09161h7.50219c.81461,0,1.47498,.66037,1.47498,1.47498v35.65545c0,.81461,.66037,1.47498,1.47498,1.47498h35.65545c.81461,0,1.47498,.66037,1.47498,1.47498v7.50333c0,.81461-.66037,1.47498-1.47498,1.47498h-35.65545c-.81461,0-1.47498,.66037-1.47498,1.47498v35.65545c0,.81461-.66037,1.47498-1.47498,1.47498h-7.50219c-.81461,0-1.47498-.66037-1.47498-1.47498v-35.65545c0-.81461-.66037-1.47498-1.47498-1.47498h-35.65545c-.81461,0-1.47498-.66037-1.47498-1.47498v-7.50333c0-.81461,.66037-1.47498,1.47498-1.47498h35.65545c.81461,0,1.47498-.66037,1.47498-1.47498v-35.65545c0-.81461,.66037-1.47498,1.47498-1.47498Z"/>
                </svg>
                <span className="mt-2 block text-sm font-medium text-gray-900">Click here to add a new bucket</span>
            </button>
            <RenderBuckets/>
        </ul>
    )
}
